import { NXBridge } from '@/utils/bridge'
window.bridgeInstance = new NXBridge()